<template>
    <div class="fooder w1200">
        
        <div class="links">
            <div class="fc"
                 v-if="linkListDb.fc.length">
                <a href="https://www.cwl.gov.cn/">
                    <img src="@/assets/links/1.png"
                         alt="">
                </a>
                <div>
                    <a v-for="(item,index) in linkListDb.fc"
                       :key="index"
                       :href="item.linkAddress"
                       target="_blank">{{ item.linkName }}</a>
                </div>
            </div>
            <div class="tc"
                 v-if="linkListDb.tc.length">
                <a href="https://www.lottery.gov.cn/">
                    <img src="@/assets/links/2.png"
                         alt="">
                </a>
                <div>
                    <a v-for="(item,index) in linkListDb.tc"
                       :key="index"
                       :href="item.linkAddress"
                       target="_blank">{{ item.linkName }}</a>
                </div>
            </div>
            
            <!-- <span>友情链接:</span>
			<div>
				<a v-for="(item,index) in linkListDb" :key="index" :href="item.linkAddress" target="_blank">{{item.linkName}}</a>
			</div> -->
        </div>
        
        <div class="aboutList">
            <!-- <span @click="gotoLink('http://cc.36886.net/about.php')">关于我们</span>
            <span @click="gotoLink('http://cc.36886.net/legal.php')">法律规则</span>
            <span @click="gotoLink('http://cc.36886.net/touch.php')">联系我们</span>
            <span @click="gotoLink('http://cc.36886.net/payway.php')">支付方式</span>
            <span @click="gotoLink('http://cc.36886.net/job.php')">人才招聘</span> -->
            
            <!-- <span @click="gotoLink('/indexFooderAboutPagee','1')">关于我们</span>
            <span @click="gotoLink('/indexFooderAboutPagee','2')">法律规则</span>
            <span @click="gotoLink('/indexFooderAboutPagee','3')">联系我们</span>
            <span @click="gotoLink('/indexFooderAboutPagee','4')">支付方式</span>
            <span @click="gotoLink('/indexFooderAboutPagee','5')">人才招聘</span> -->
            
            <span @click="gotoLink({ path: '/indexFooderAboutPage', query:{type:'1'}})">关于我们</span>
            <span @click="gotoLink({ path: '/indexFooderAboutPage', query:{type:'2'}})">法律规则</span>
            <span @click="gotoLink({ path: '/indexFooderAboutPage', query:{type:'3'}})">联系我们</span>
            <span @click="payMethods">支付方式</span>
            <span @click="gotoLink({ path: '/indexFooderAboutPage', query:{type:'5'}})">人才招聘</span>
        
        </div>
        <div>
            Copyright @ 2021-2022 湖北省潜江市晖喆商务信息服务部 (中心) 版权所有Al
            Rights Reserved
        </div>
        <div>公司地址: 湖北省潜江市&湖南省长沙市ICP:鄂ICP备2021020794号</div>
    </div>
</template>

<script>
import {linkList} from '@/api/common'

export default {
    data() {
        return {
            linkListDb: {
                fc: [],
                tc: [],
            },
        }
    },
    async mounted() {
        
        let linksType = await this.$http.get('/stage-api/pre/dict/type/' + 'pre_lottery_ticket_type')
        
        let type = [
            {num: null, name: '福彩', type: 'fc'},
            {num: null, name: '体彩', type: 'tc'},
        ];
        
        type.forEach(item => {
            item.num = linksType.data.filter(ite => item.name == ite.dictLabel)[0].dictValue
            this.getLinklist(item)
        })
        // this.getLinklist({num:0,type:'fc'})
        // this.getLinklist({num:1,type:'tc'})
    },
    methods: {
        payMethods() {
            this.$router.push('/personalCenter/chongzhihetixian/suobichongzhi');
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        },
        gotoLink(url, type) {
            window.open(this.$router.resolve(url).href, '_blank');
            window.scrollTo({
                top: 0,
            });
        },
        getLinklist(params) {
            linkList({
                type: params.num,
                pageSize: 100,
                status: 0,
            }).then(res => {
                this.linkListDb[params.type] = res.rows
            })
        },
    }
};
</script>

<style lang="scss" scoped>
.fooder {
    text-align: center;
    
    div {
        margin: 20px 0;
        
        span {
            padding: 0 30px;
        }
    }
    
    .links {
        > div {
            display: flex;
            align-items: center;
            margin: 0;
            margin-bottom: 30px;
            
            img {
                width: 200px;
                margin-right: 20px;
                
                &:hover {
                    transition: transform 0.5s;
                    transform: scale(1.1);
                }
                
                &:not(:hover) {
                    transition: transform 0.5s;
                    transform: scale(1);
                }
            }
            
            > div {
                display: flex;
                flex-wrap: wrap;
                gap: 15px;
                margin: 0;
                
                a {
                    line-height: 20px;
                    
                    &:hover {
                        transition: transform 0.5s;
                        transform: scale(1.1);
                        font-weight: 900;
                    }
                    
                    &:not(:hover) {
                        transition: font-weight 0.5s;
                        transform: scale(1);
                        font-weight: 400;
                    }
                }
            }
        }
    }
    
    .aboutList {
        display: flex;
        justify-content: center;
        
        > span {
            cursor: pointer;
            display: block;
            
            &:hover {
                transition: transform 0.5s;
                transform: scale(1.1);
                font-weight: 900;
            }
            
            &:not(:hover) {
                transition: font-weight 0.5s;
                transform: scale(1);
                font-weight: 400;
            }
        }
    }
}

/* ===== 移动端适配 ===== */
@media (max-width: 768px) {
    .fooder {
        div {
            margin: 12px 0;
        }

        .links > div {
            flex-direction: column;
            align-items: center;

            img {
                width: 140px;
                margin-right: 0;
                margin-bottom: 10px;
            }

            > div {
                justify-content: center;
            }
        }

        .aboutList {
            flex-wrap: wrap;
            gap: 6px;

            > span {
                padding: 4px 12px;
                font-size: 13px;
            }
        }
    }
}
</style>
